import React from 'react';
import './InlinePhoto.scss';
import photoData from './photoData';

function InlinePhoto({ index, photoRef, photoSize }) {
  const data = photoSize === 'fullBleed' ? photoData.inlineFb : photoData.inline;
  return (
    <section
      className={
        photoSize === 'fullBleed' ? 'inline inline--fullbleed' : 'inline inline--contentWidth'
      }
    >
      <div
        className={
          photoSize === 'fullBleed'
            ? `inline__image inline__image--fullbleed`
            : `inline__image inline__image--contentWidth`
        }
      >
        <div
          ref={photoRef}
          className={
            photoSize === 'fullBleed'
              ? `inline__image-image inline__image-image--fullbleed inline__image-image--${data[index].class}`
              : `inline__image-image inline__image-image--contentWidth  inline__image-image--${data[index].class}`
          }
        />
      </div>
      {data[index].caption ? (
        <div className="inline__caption">
          {data[index].caption} <span className="inline__caption--source">(Allogene)</span>
        </div>
      ) : (
        <></>
      )}
    </section>
  );
}

export default InlinePhoto;
